import GridExportMenu from "../../../../components/gridexportmenu/GridExportMenu";
import { HashTypeEnum } from "../../../../lib/enums";
import { route } from "../../../../shim/jsbridge";
import { ExtractedFilesData, ExtractedFilesResultItem } from "../../@types";
import { exportMenuItems } from "./const";

type Props = {
  sampleHash: string;
  sampleRelationshipId: number;
  threatStatus: string;
  fileName: string;
  fileFormat: string;
  threatName: string;
  samplePath: string;
  downloadExtractedFiles: (exportRoute: string) => void;
  sampleData: ExtractedFilesData;
  selectedSamples?: Record<string, ExtractedFilesResultItem>;
  auxiliaryExport?: boolean;
  ordering?: string;
};

const ExtractedFilesTableExport = ({
  sampleHash,
  sampleRelationshipId,
  threatStatus,
  fileName,
  fileFormat,
  samplePath,
  threatName,
  sampleData,
  downloadExtractedFiles,
  selectedSamples,
  auxiliaryExport = false,
  ordering = ""
}: Props): JSX.Element => {
  const samplesData = sampleData.map(item => item.sample);
  const hashSamplesMap = selectedSamples
    ? Object.fromEntries(
        Object.values(selectedSamples).map(({ sample }) => [
          sample.sha1,
          sample
        ])
      )
    : {};

  const onApplyClick = (fieldData: Record<string, string>) => {
    const { format, fields } = fieldData;
    const fieldStatusMap = exportMenuItems.reduce(
      (obj, item) => ({ ...obj, [item.value]: fields.includes(item.value) }),
      {}
    );

    if (auxiliaryExport) {
      const params = {
        ...fieldStatusMap,
        export_format: format,
        threat_status: threatStatus,
        threat_name: threatName,
        filename: fileName,
        file_format: fileFormat,
        ordering
      };
      const qp = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v)
      );
      downloadExtractedFiles(
        route(
          "api_rl_auxiliary_analysis_extracted_files_export",
          [sampleHash],
          qp
        )
      );
      return;
    }

    const params = {
      ...fieldStatusMap,
      export_format: format,
      hash_type: HashTypeEnum.SHA1,
      relationship: sampleRelationshipId,
      threat_status: threatStatus,
      threat_name: threatName,
      filename: fileName,
      file_format: fileFormat,
      path: samplePath || "/"
    };
    const qp = Object.fromEntries(Object.entries(params).filter(([_, v]) => v));
    downloadExtractedFiles(route("api-sample-export-files", [sampleHash], qp));
  };

  return (
    <GridExportMenu
      onGridExport={onApplyClick}
      fieldMenuItems={exportMenuItems}
      samples={samplesData}
      showScopeNote={false}
      className="pull-right"
      selectedSamples={hashSamplesMap}
    />
  );
};

export default ExtractedFilesTableExport;
